import { readable } from 'svelte/store';
import config from './config.js';

export const synchronizerToken = readable(config.synchronizerToken);

export const i18n = readable(config.i18n);
